import { useRef } from 'react'

const LabelForm = ({ onAdd }) => {
  const refForm = useRef()

  const handleSubmit = (e) => {
    e.preventDefault()
    const formData = new FormData(refForm.current)

    const data = {
      UPC: formData.get('UPC'),
      TITLE: formData.get('TITLE'),
      CN_TITLE: formData.get('CN_TITLE'),
      SIZE: formData.get('SIZE'),
      UNIT: formData.get('UNIT'),
      PRICE: formData.get('PRICE'),
    }

    onAdd(data) // 通过 props 把数据传回父组件
    // refForm.current.reset() // 提交后清空表单（可选）
  }

  return (
    <form ref={refForm} onSubmit={handleSubmit}>
      <ul>
        <li>
          <input
            type="number"
            step="0.01"
            placeholder="BARCODE - UPC"
            name="UPC"
            required
          />
        </li>
        <li>
          <input
            type="text"
            placeholder="TITLE - 英文名"
            name="TITLE"
            required
          />
        </li>
        <li>
          <input type="text" placeholder="TITLE - 中文名" name="CN_TITLE" />
        </li>
        <li>
          <input
            type="number"
            step="0.01"
            placeholder="SIZE - 重量"
            name="SIZE"
            required
          />
        </li>
        <li>
          <select name="UNIT" required>
            <option value="PER - OZ" defaultChecked>
              PER - OZ
            </option>
            <option value="PER - PC">PER - PC</option>
            <option value="PER - KG">PER - KG</option>
            <option value="PER - LB">PER - LB</option>
            <option value="PER - L">PER - L</option>
          </select>
        </li>
        <li>
          <input
            type="number"
            step="0.01"
            placeholder="PRICE - 价格"
            name="PRICE"
            required
          />
        </li>
        <li>
          <button type="submit" className="flat-button">
            ADD TO LIST
          </button>
        </li>
      </ul>
    </form>
  )
}

export default LabelForm
